import { render, staticRenderFns } from "./hunt-event.vue?vue&type=template&id=6e70b947&scoped=true&"
import script from "./hunt-event.vue?vue&type=script&lang=js&"
export * from "./hunt-event.vue?vue&type=script&lang=js&"
import style0 from "./hunt-event.vue?vue&type=style&index=0&id=6e70b947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70b947",
  null
  
)

export default component.exports